import React, { useEffect, useState } from 'react'
import './opportunity-card-component.scss'
import { LastMinuteListPropsV1, OpportunityCardProps } from '../../types'
import { calculateRemainingDays } from '../../utils/helpers'
import { H4 } from '../Heading'
import { EyeIcon, EditIcon } from '../Icon'

function OpportunityCard({
  id,
  opportunitySlug,
  opportunityTitle,
  assetClass,
  expectedReturn,
  ticketSize,
  handleClick,
  status,
  committedPercentage,
  handleProjectInvestmentClick,
  handleProjectWithdrawalClick,
  closingDate,
  displayOrder,
  canEditOrder = false,
  handleDisplayOrderSave,
}: OpportunityCardProps) {
  const closeDays = Number(closingDate && calculateRemainingDays(new Date(), new Date(closingDate)))
  const [orderValue, setOrderValue] = useState(
    displayOrder === null || displayOrder === undefined ? '' : String(displayOrder),
  )

  useEffect(() => {
    setOrderValue(displayOrder === null || displayOrder === undefined ? '' : String(displayOrder))
  }, [displayOrder])

  const persistOrder = () => {
    if (!canEditOrder || !handleDisplayOrderSave) return
    handleDisplayOrderSave(id, orderValue)
  }

  return (
    <tr key={id}>
      <td>{opportunityTitle}</td>
      <td>{assetClass}</td>
      <td> {expectedReturn} </td>
      <td> {ticketSize} </td>
      <td> {committedPercentage} </td>
      <td>{closeDays < 2 ? `${closeDays} day left` : `${closeDays} days left`}</td>
      <td> {status}</td>
      <td>
        <input
          type='number'
          min={0}
          step={1}
          className='input-field opportunity-order-input'
          name={`display_order_${id}`}
          value={orderValue}
          disabled={!canEditOrder}
          placeholder='—'
          onChange={(e) => setOrderValue(e.target.value)}
          onBlur={persistOrder}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.currentTarget.blur()
            }
          }}
          data-testid={`opportunity-order-input-${id}`}
        />
      </td>
      <td>
        <EyeIcon
          classes={['align-center', 'pointer']}
          height='24px'
          width='24px'
          onClick={() => handleProjectInvestmentClick(opportunityTitle, opportunitySlug, id)}
          dataTestId='opportunity-list-card-investments-icon'
        />
      </td>
      <td>
        <EyeIcon
          classes={['align-center', 'pointer']}
          height='24px'
          width='24px'
          onClick={() => handleProjectWithdrawalClick(opportunityTitle, opportunitySlug, id)}
          dataTestId='opportunity-list-card-withdrawals-icon'
        />
      </td>
      <td>
        <EditIcon
          classes={['align-center', 'pointer']}
          height='24'
          width='24'
          onClick={() => handleClick(opportunityTitle, opportunitySlug, id)}
          dataTestId='opportunity-list-card-edit-icon'
        />
      </td>
      {/* <td>
    <DeleteIcon
      classes={['align-center', 'pointer']}
      onClick={() => handleProjectDelete(id)}
    />
  </td> */}
    </tr>
  )
}
export { OpportunityCard }

function OpportunityCardHorizontal({
  opportunitySlug: opportunity_slug,
  opportunityTitle: opportunity_title,
  committedPercentage,
  opportunitySummary: opportunity_summary,
  opportunityCover: opportunity_cover,
  handleClick,
  closingDate: closing_date,
}: LastMinuteListPropsV1) {
  return (
    <div
      className='project-h-container'
      onClick={() => handleClick && handleClick(opportunity_slug)}
    >
      <div className='project-h-image'>
        <img src={opportunity_cover} alt='' />
      </div>
      <div className='project-h-content'>
        <div className='project-h-text'>
          <H4 text={opportunity_title} />
          <p>{opportunity_summary}</p>
        </div>
        <div className='project-h-stats'>
          <p>
            <strong>{committedPercentage}</strong> committed
          </p>
          <p>
            {closing_date && calculateRemainingDays(new Date(), new Date(closing_date))}{' '}
            <strong>days</strong>
          </p>
        </div>
      </div>
    </div>
  )
}

export { OpportunityCardHorizontal }
